import {
  assignProps,
  findMatch,
  removeItemByID,
} from '@/utils/resultsHelper';
import { responseError } from '@/utils/errors';
import { destroyStates, states, updateStates } from '@/constants/lifecycle';
import withDraft from '@/utils/draftHelper';
import { findUserGroup, usergroupUserSearchState } from './state';
import { usergroupUsersActions } from '../constants';
import { sortByID, updateUsergroupUsersMetrics, withUserStates } from '../helper';

const fetchUsergroupUsers = withDraft((draft, action) => {
  const item = findUserGroup(draft, action);
  item.users.readStatus = states.PENDING;
  item.users.readErrors = [];
});

const showUsergroupUsers = withDraft((draft, action) => {
  const item = findUserGroup(draft, action);
  item.users.results = action.users.map(withUserStates).sort(sortByID);
  item.users.readStatus = states.SUCCESS;
  item.users.readErrors = [];
  updateUsergroupUsersMetrics(draft, item);
});

const showUsergroupUsersError = withDraft((draft, action) => {
  const item = findUserGroup(draft, action);
  item.users.readStatus = states.ERROR;
  item.users.readErrors = [responseError(action)];
});

const updateUsergroupUsersToAdd = withDraft((draft, action) => {
  const item = findUserGroup(draft, action);
  item.users.toAdd = action.users;
});

const addUsergroupUsers = withDraft((draft, action) => {
  const item = findUserGroup(draft, action);
  item.users.updateStatus = states.PENDING;
  item.users.updateErrors = [];
});

const addUsergroupUsersError = withDraft((draft, action) => {
  const item = findUserGroup(draft, action);
  item.users.updateStatus = states.ERROR;
  item.users.updateErrors = action.errors.map((error) => responseError(error));
});

const addUsergroupUsersSuccess = withDraft((draft, action) => {
  const item = findUserGroup(draft, action);
  item.users.updateStatus = states.SUCCESS;
  item.users.results.push(...action.results.map(withUserStates));
  item.users.results = item.users.results.sort(sortByID);
  item.users.toAdd = item.users.toAdd.filter(
    (previousUser) => !action.results.some(
      (existingUser) => existingUser.id === previousUser.id,
    ),
  );
  item.users.updateErrors = [];
  item.userSearch = usergroupUserSearchState();

  updateUsergroupUsersMetrics(draft, item);
});

const addUsergroupUsersLocal = withDraft((draft, action) => {
  const item = findUserGroup(draft, action);
  item.users.results.push(...action.results.map(withUserStates));
  item.users.results = item.users.results.sort(sortByID);
  item.users.toAdd = item.users.toAdd.filter(
    (previousUser) => !action.results.some(
      (existingUser) => existingUser.id === previousUser.id,
    ),
  );
});

const removeUsergroupUser = withDraft((draft, action) => {
  const item = findUserGroup(draft, action);
  const user = findMatch(item.users.results, action.userId, 'id');

  user.destroyStatus = states.PENDING;
  user.destroyErrors = [];
  item.users.destroyStatus = states.PENDING;
  item.users.destroyErrors = [];
});

const removeUsergroupUserError = withDraft((draft, action) => {
  const item = findUserGroup(draft, action);
  const user = findMatch(item.users.results, action.user.id, 'id');

  user.destroyStatus = states.ERROR;
  user.destroyErrors = [responseError(action)];
  item.users.destroyStatus = states.ERROR;
  item.users.destroyErrors = [responseError(action)];
});

const removeUsergroupUserSuccess = withDraft((draft, action) => {
  const item = findUserGroup(draft, action);
  assignProps(item.users, {
    destroyStatus: states.SUCCESS,
    destroyErrors: [],
    results: removeItemByID(item.users.results, { id: action.user.id }),
  });
  updateUsergroupUsersMetrics(draft, item);
});

const removeUsergroupUserLocal = withDraft((draft, action) => {
  const item = findUserGroup(draft, action);
  assignProps(item.users, { results: removeItemByID(item.users.results, { id: action.user.id }) });
});

const dismissUsergroupUsersError = withDraft((draft, action) => {
  const item = findUserGroup(draft, action);
  assignProps(item.users, { ...updateStates, ...destroyStates });
});

export default {
  [usergroupUsersActions.ADD_USERGROUP_USERS]: addUsergroupUsers,
  [usergroupUsersActions.ADD_USERGROUP_USERS_ERROR]: addUsergroupUsersError,
  [usergroupUsersActions.ADD_USERGROUP_USERS_LOCAL]: addUsergroupUsersLocal,
  [usergroupUsersActions.ADD_USERGROUP_USERS_SUCCESS]: addUsergroupUsersSuccess,
  [usergroupUsersActions.DISMISS_USERGROUP_USERS_ERROR]: dismissUsergroupUsersError,
  [usergroupUsersActions.FETCH_USERGROUP_USERS]: fetchUsergroupUsers,
  [usergroupUsersActions.REMOVE_USERGROUP_USER]: removeUsergroupUser,
  [usergroupUsersActions.REMOVE_USERGROUP_USER_ERROR]: removeUsergroupUserError,
  [usergroupUsersActions.REMOVE_USERGROUP_USER_LOCAL]: removeUsergroupUserLocal,
  [usergroupUsersActions.REMOVE_USERGROUP_USER_SUCCESS]: removeUsergroupUserSuccess,
  [usergroupUsersActions.SHOW_USERGROUP_USERS]: showUsergroupUsers,
  [usergroupUsersActions.SHOW_USERGROUP_USERS_ERROR]: showUsergroupUsersError,
  [usergroupUsersActions.UPDATE_USERGROUP_USERS_TO_ADD]: updateUsergroupUsersToAdd,
};
